import angular from 'angular';
import app from './app';

angular
    .bootstrap(document.getElementById('locations-map-app'), [app.name])
;
